import axios from "axios";
import { Message } from "element-ui";
import { getToken } from "./wapAuth";

// Create axios instance
const service = axios.create({
  baseURL: process.env.MIX_BASE_API,
  timeout: 60 * 10 * 1000, // Request timeout
  headers: {
    Authorization: `Bearer ` + getToken().token,
    "Access-Control-Allow-Origin": "*" // Allow CORS
  }
});

// request拦截器
service.interceptors.request.use(
  config => {
    const { token, vga } = getToken();
    if (vga) config.params = { ...config.params, uid: vga };

    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    let route_token = params.get("token");

    // console.log(window.location.href);
    if (token || route_token)
      config.headers["Authorization"] = `Bearer ${token || route_token}`;
    // Set JWT token
    else {
      // if (window.location.pathname !== "/404") window.location.replace("/404");
    }
    return config;
  },
  error => {
    console.log(error, "123123"); // for debug
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    if (response.data.error_code !== 0) console.log(response.data);
    return response.data;
  },
  error => {
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
